<template>
<li class="project-item" >
          <NuxtLink v-if="proj.title" :to="`/projets/${proj.id}`" :title="`voir le projet ${proj.title.rendered}`">
               <div v-if="proj.featured_media !== 0" class="has-img">
                <NuxtImg 
                  :src="proj.featured_media_url"
                  format="webp"
                  lazy="loading"
                  />
                  <div class="project-legend"><p>{{proj.title.rendered}}</p> </div>
               </div>
               <div v-else class="no-img">
                <div class="project-legend"><p>{{proj.title.rendered}}</p> </div>
               </div>
            </NuxtLink>
        </li>
</template>
<script setup lang='ts'>
import type {Project } from '~/types/projects';

/*  VARIABLES  */
const props = defineProps<{
    proj:Project | Partial<Project>
}>()





/*  FUNCTIONS  */
</script>

<style lang="scss">
    .project-item{
                flex: 0 0 33%;
                max-width: calc(33% - 1rem);
                height: 350px;
                @media screen and (max-width:1035px) {
                    flex:  0 0 50%;
                    max-width: calc(50% - 2rem);
                }
                @media screen and (max-width:550px) {
                    flex:  0 0 100%;
                    max-width: 90%;
                    margin:auto;
                    height: 250px;
                }
                a{
                    height: 100%;
                    display: block; 
                    text-decoration: none;
                    position: relative;
                    &:hover,&:focus{
                       .has-img{
                         .project-legend{
                            height: 100%;
                            background-color: rgba($color: $violet, $alpha: .65);
                            opacity: 1;
                        }
                       }
                    }
                    .has-img,.no-img{
                        height: 100%;
                    }
                    .has-img{
                         .project-legend{
                            position: absolute;
                            top: 0;
                            left: 0;
                            height: 0;
                            opacity: 0;
                            transition: all .2s;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 22px;
                            font-weight: 500;
                            color: $white;
                            p{
                                padding: 0 10px;
                            }
                    }
                    }
                    .no-img{
                        background-color: $violet;
                         .project-legend{
                        transition: all .2s;
                        width: 100%;
                        display: flex;
                        height: 100%;
                        align-items: center;
                        justify-content: center;
                        font-size: 22px;
                        font-weight: 500;
                        color: $white;
                    }
                    }
                    
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .no-picture{
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: $violet_light;
                    color: $text;
                    font-weight: 500;
                    font-size: 18px;
                }
               
    }
</style>